<template>
  <div class="c-medication-adherence-barriers">
    <v-row :class="{'mb-3 pb-3 border-bottom': red.length || orange.length}" v-if="green.length">
      <v-col class="py-0">
        <p class="mb-2">{{ $ucfirst($t('medication.noBarrier'))}}</p>
        <v-chip-group column>
          <v-chip
            v-for="n in green"
            :key="n"
            class="c-medication-adherence-barriers__chip c-medication-adherence-barriers__chip-green"
            :text-color="$color.coro['success-600']"
            :color="$color.coro['success-transparent-300']"
          >
            {{n}}
          </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
    <v-row :class="{'mb-3 pb-3 border-bottom': red.length}" v-if="orange.length">
      <v-col class="py-0">
        <p class="mb-2">{{ $ucfirst($t('medication.smallBarrier'))}}</p>
        <v-chip-group column>
          <v-chip
            v-for="n in orange"
            :key="n"
            class="c-medication-adherence-barriers__chip c-medication-adherence-barriers__chip-orange"
            :text-color="$color.coro['warning-600']"
            :color="$color.coro['warning-transparent-300']"
          >
            {{n}}
          </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
    <v-row v-if="red.length">
      <v-col class="py-0">
        <p class="mb-2">{{ $ucfirst($t('medication.bigBarrier'))}}</p>
        <v-chip-group column>
          <v-chip
            v-for="n in red"
            :key="n"
            class="c-medication-adherence-barriers__chip c-medication-adherence-barriers__chip-red"
            :text-color="$color.coro['danger-600']"
            :color="$color.coro['danger-transparent-300']"
          >
            {{n}}
          </v-chip>
        </v-chip-group>
      </v-col>
    </v-row>
    <v-row v-if="!red.length && !green.length && !orange.length && !noData">
      <v-col class="pl-0">
        <span>{{ $ucfirst($t('medication.noBarriers')) }}</span>
      </v-col>
    </v-row>
    <v-row v-if="!red.length && !green.length && !orange.length && noData">
      <v-col>
        <span>{{ $ucfirst($t('noData')) }}</span>
      </v-col>
    </v-row>
  </div>
</template>

<script>
/**
 * Component MedicationAdherenceBarriers.vue
 *
 * @module MedicationAdherenceBarriers
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.6] app/src/APP_DASHBOARD/templates/components/Parts/MedicationAdherenceBarriers.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "MedicationAdherenceBarriers",
  components: {},
  props: {
    green: {
      type: Array,
      default: function () {
        return []
      },
    },
    orange: {
      type: Array,
      default: function () {
        return []
      },
    },
    red: {
      type: Array,
      default: function () {
        return []
      },
    },
    noData: {
      type: Boolean,
      default: function () {
        return false
      },
    }
  }
};
</script>
<style lang="scss">
    .c-medication-adherence-barriers__chip {
        pointer-events: none;
    }
</style>